module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    attrs: {
      "id": "menu-inner"
    }
  }, [_c('h4', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Thomas van Krugten")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "contact"
    }
  }, [_vm._l((_vm.basic), function(data, index) {
    return (data['.key'] == 'contact') ? _c('li', {
      key: index
    }, [_vm._v(_vm._s(data.phone))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.basic), function(data, index) {
    return (data['.key'] == 'contact') ? _c('li', {
      key: index
    }, [_vm._v(_vm._s(data.email))]) : _vm._e()
  }), _vm._v(" "), _vm._m(1)], 2), _vm._v(" "), _c('span', {
    attrs: {
      "id": "separator"
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "main-nav"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "work",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Work")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "bio",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Bio")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "mobm"
    }
  }, [_c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "bar top"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar bottom"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://vimeo.com/thomasvankrugten",
      "target": "_blank"
    }
  }, [_vm._v("vimeo.com/thomasvankrugten")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5631839c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 247
// module chunks = 4